import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { AdminUserBase } from "@preveil-api";
import { Icon } from "src/components";
import _ from "lodash";

type AllProps = {
  members: AdminUserBase[];
  removeUser?: Function;
};

// Description: MembersTableComponent is a React component that displays a table of members with their details
// and an optional delete button.
function MembersTableComponent(props: AllProps) {
  const { members, removeUser } = props;

  return <div className="table-display mt-3">
    <Row className="header-card-row">
      <Col xs={6}>
        <p>User</p>
      </Col>
      <Col xs={5}>
        <p>Department</p>
      </Col>
    </Row>
    <div className="table-body">
      {_.map(members, (member: AdminUserBase, index: number) => {
        const { display_name, user_id, department } = member;
        return <Row key={index}>
          <Col xs={6}>
            <p className="semi-bold">{display_name}</p>
            <p>{user_id}</p>
          </Col>
          <Col xs={5}>
            <p className="m-0">{department}</p>
          </Col>
          {!!removeUser && <Col xs={1}>
            <Button 
              variant="icon"
              size="sm"
              aria-label="Remove User from Group"
              onClick={() => removeUser([user_id])}>
              <Icon className="ficon-x" />
            </Button>
          </Col>}
        </Row>;
      })}
    </div>
  </div>;
}

export default React.memo(MembersTableComponent);
